import { createContext } from "react";
export const MultipleCheckboxInputContext = createContext<{
  onCheck: (value: any) => void;
  onUncheck: (value: any) => void;
  selected: any[];
  size: "small" | "medium" | "large";
}>({ size: "medium", selected: [], onCheck: () => {}, onUncheck: () => {} });
